import styled from "styled-components";

export const SectionLayout = styled.section`
  padding: 8rem 18rem;
  @media screen and (max-width: 1600px) {
    padding: 8rem 10rem;
  }
  @media screen and (max-width: 1150px) {
    padding: 6rem 6rem;
  }
  @media screen and (max-width: 650px) {
    padding: 3rem 3rem;
  }
`;
